import React, { useCallback } from 'react';
import Link from 'next/link';

import { useHat } from '@r1-frontend/entities/Layout/Header/commonComponents/Hat/useHat';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import * as ST from './styled';

const Hat = (): JSX.Element | null => {
    const { promoline, isShowPromoLine } = useHat() || {
        promoline: undefined,
        isShowPromoLine: false,
    };

    const sendGTMevent = useCallback(() => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.bannerOverHeader,
            action: ACTIONS.clickBanner,
            label: 'click',
        });
    }, []);

    const advertising = promoline?.advertising;

    if (!isShowPromoLine) {
        return null;
    }

    return <ST.HatWrapperWithIndent data-test='header-hat'>
        <div id='hat'>
            {promoline
                ? <>
                    <Link href={promoline.url} passHref prefetch={false} data-test='header-hat-link'>
                        <ST.HatLink onClick={sendGTMevent} image={promoline.image_webp ?? promoline.image}/>
                    </Link>
                    {advertising && (
                        <NonStaticContainer
                            $united={{
                                $bottom: 0,
                                $right: 0,
                            }}
                        >
                            <AdvertisingLabelWithTooltip
                                companyName={advertising.companyName}
                                erid={advertising.erid}
                                tooltip={{
                                    position: 'left',
                                    zIndex: 999,
                                }}
                            />
                        </NonStaticContainer>
                    )}
                </>
                : null}
        </div>
    </ST.HatWrapperWithIndent>;
};

export default Hat;
